"use strict";
exports.__esModule = true;
// Gets the position of an element relative to the whole page
var getAbsoluteElementPos = function (element) {
    var bodyRect = document.body.getBoundingClientRect();
    var elemRect = element.getBoundingClientRect();
    var top = elemRect.top - bodyRect.top;
    var left = elemRect.left - bodyRect.left;
    return {
        top: top,
        left: left
    };
};
// Hide it
var resetHover = function () {
    var globalPopover = document.getElementById('twoslash-mouse-hover-info');
    if (globalPopover)
        globalPopover.style.display = 'none';
};
// Get it
var findOrCreateTooltip = function () {
    var globalPopover = document.getElementById('twoslash-mouse-hover-info');
    if (!globalPopover) {
        globalPopover = document.createElement('div');
        globalPopover.style.position = 'absolute';
        globalPopover.id = 'twoslash-mouse-hover-info';
        document.body.appendChild(globalPopover);
    }
    return globalPopover;
};
/**
 * Creates the main mouse over popup for LSP info using the DOM API.
 * It is expected to be run inside a `useEffect` block inside your main
 * exported component in Gatsby.
 *
 * @example
 * import React, { useEffect } from "react"
 * import { setupTwoslashHovers } from "gatsby-remark-shiki-twoslash/dom";
 *
 * export default () => {
 *   // Add a the hovers
 *   useEffect(setupTwoslashHovers, [])
 *
 *   // Normal JSX
 *   return </>
 * }
 *
 */
exports.setupTwoslashHovers = function () {
    // prettier-ignore
    var twoslashes = document.querySelectorAll(".shiki.twoslash .code-container code");
    // Gets triggered on the spans inside the codeblocks
    var hover = function (event) {
        var hovered = event.target;
        if (hovered.nodeName !== 'DATA-LSP')
            return resetHover();
        var message = hovered.getAttribute('lsp');
        var position = getAbsoluteElementPos(hovered);
        // Create or re-use the current hover dic
        var tooltip = findOrCreateTooltip();
        // Use a textarea to un-htmlencode for presenting to the user
        var txt = document.createElement('textarea');
        txt.innerHTML = message;
        tooltip.textContent = txt.value;
        // Offset it a bit from the mouse and present it at an absolute position
        var yOffset = 20;
        tooltip.style.display = 'block';
        tooltip.style.top = position.top + yOffset + "px";
        tooltip.style.left = position.left + "px";
    };
    twoslashes.forEach(function (codeblock) {
        codeblock.addEventListener('mouseover', hover);
        codeblock.addEventListener('mouseout', resetHover);
    });
};
